import { z } from "zod";

const ersContactSchema = z.object({
  name: z.string().min(1, "Name is required"),
  phone: z
    .string()
    .regex(/^\(\d{3}\) \d{3}-\d{4}$/, "Enter a valid 10-digit phone number"),
  relationship: z.string().optional(),
});

export const createErsSessionSchema = z.object({
  leadId: z.string().uuid(),
  policyId: z.string().uuid().optional(),
  contacts: z
    .array(ersContactSchema)
    .min(1, "At least 1 contact required")
    .max(10, "Maximum 10 contacts"),
  messageTemplate: z.string().optional(),
  notes: z.string().optional(),
});

export type CreateErsSessionSchema = z.infer<typeof createErsSessionSchema>;
export type ErsContactSchema = z.infer<typeof ersContactSchema>;
